import {
    postapicallnetworkservice,
    getapicallnetworkservice
} from '../apicallservice'
import keycloak from '../../src/common/Keycloak';
/**
 *
 * @param {Object} payload
 *
 * get Delivery SR Details.
 */
export const getHubDeliverySRListByHubID = async(payload, sendResult) => {
    let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
    if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/gethubdeliveryuserlist';
    }
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * get Pending for allocation shipment Details.
 */
export const getPendingforallocationList = async(payload, sendResult) => {
        try {
            let apiendpoint = 'expose/get/pending/shipment/details'
            let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
            sendResult(resultData)

        } catch (e) {
            return false
            console.log('ERRROR --->>', e);
        }
    }
    /**
     *
     * @param {Object} payload
     *
     * get Client List.
     */
export const ClientNameList = async(payload, sendResult) => {
    let apiendpoint = 'external/getclientlist'
    let resultData = await getapicallnetworkservice('get', apiendpoint, payload)
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * get Allocated Details.
 */
export const AllocatedShipmentDetails = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/get/allocated/shipments/List'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * Allocate Shipments.
 */
export const AllocateShipment = async(payload, sendResult) => {
    try {
        let apiendpoint = 'expose/shipment/allocate'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    } catch (error) {
        sendResult(error)
    }
}

/**
 *
 * @param {Object} payload
 *
 * EODVAlidation.
 */
export const validateEODAllocation = async(payload, sendResult) => {
        let apiendpoint = 'DayEndClosure/validateEODAllocation/deliveryuserid'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
            // console.log('resultData ---------->>', resultData);
        sendResult(resultData)
    }
    /**
     *
     * @param {Object} payload
     *
     * Verify TriDetails.
     */
export const TriDetails = async(payload, sendResult) => {
    let apiendpoint = 'expose/trip/tripDetails'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 *Previous Day Attempted Shipment List.
 */
export const PreviousDayShipment = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/shipment/previouslyAllocatedPendingShipmentBySrId'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 *Get IsRSVSr flag.
 */
export const GetHubFlags1 = async(payload, sendResult) => {
    let apiendpoint = 'expose/hubservicecenter/getHubFlags'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 *Get IsRSVSr flag.
 */
export const PendingList = async(payload, sendResult) => {
    let apiendpoint = 'expose/shipment/previous'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}



/**
 *
 * @param {Object} payload
 *
 * get Service Type List.
 */
export const ServiceType = async(payload, sendResult) => {
        let apiendpoint = 'exposeallocationapis/shipment/serviceTypeList'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
            // console.log('resultData ---------->>', resultData);
        sendResult(resultData)
    }
    /**
     *
     * @param {Object} payload
     *
     * Close Trip.
     */
export const CloseTrip1 = async(payload, sendResult) => {
    let apiendpoint = 'expose/trip/close'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * get vehicle list.
 */
export const VehicleList1 = async(payload, sendResult) => {
        let apiendpoint = 'expose/GetVendorVehiclesForLastMile'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
            // console.log('resultData ---------->>', resultData);
        sendResult(resultData)
    }
    /**
     *
     * @param {Object} payload
     *
     * get Bike list.
     */
export const GetBikeVehicleList = async(payload, sendResult) => {
        let apiendpoint = 'expose/getsrmapping'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
            // console.log('resultData ---------->>', resultData);
        sendResult(resultData)
    }
    /**
     *
     * @param {Object} payload
     *
     * Close Trip.
     */
export const CreateTrip = async(payload, sendResult) => {
    let apiendpoint = 'expose/trip/create'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * ShipmentConfirm.
 */
export const ShipmentConfirm = async(payload, sendResult) => {
    let apiendpoint = 'expose/shipment/confirm'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * ShipmentPrintDetails1.
 */
export const ShipmentPrintDetails1 = async(payload, sendResult) => {
    let apiendpoint = 'expose/get/batchid'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 * pdfData.
 */
export const pdfData1 = async(payload, sendResult) => {
    let apiendpoint = 'expose/web/get/shipmentbysrid'
    let responseType = {
        "responseType": 'blob'
    }
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload, responseType)
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 * Get SubCluster/Sameroute List
 */
export const GetSubcluster = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/shipment/getSubClusterIdsOfAllocatedShipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 * Get Escalation List
 */
export const GetEscalation1 = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/shipment/getEscalationFliters'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 * Get UnAllocated pending for allocation List
 */
export const getUnallocatedShipmentsByShipmentType = async(payload, sendResult) => {
        let apiendpoint = 'exposeallocationapis/pending/allocationShipments/byShipmentType'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    }
    /**
     * Remove Allocated Shipment
     */
export const RemoveAllocatedShipment1 = async(payload, sendResult) => {
        let apiendpoint = 'expose/shipment/remove'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    }
    /**
     * Get Shipment Count
     */
export const GetShipmentCount1 = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/get/filters/dashboard/count'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * SUBMIT RESAON
 */
export const SubmitReason1 = async(payload, sendResult) => {
        let apiendpoint = 'exposeallocationapis/shipment/srStoreNonAllocationReason'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    }
    /**
     * SEQUENCE NO
     */
export const SeqofNonAllocation = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/shipment/checkSequenceOfNonAllocationPopup'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * GET Same customer shipments
 */
export const getSameCustomerShipments = async(payload, sendResult) => {
    let apiendpoint = 'expose/get/rvp/shipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * GET GetClusterId
 */
export const GetClusterId = async(payload, sendResult) => {
        let apiendpoint = 'external/get/cluster/list'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    }
    /**
     * get config
     */
export const NewAllocationConfigFlag = async(payload, sendResult) => {
    let apiendpoint = 'exposeallocationapis/get/newallocation/configsettings'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * New Allocation as per Mobile change -> Get Dashboard count sr and svc
 */
export const getallocationDashboardCount = async(payload, sendResult) => {
    let apiendpoint = 'allocation/dashboardcounts'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * New Allocation as per Mobile change -> Get Pending shipment sr, svc with P0, P1, P2
 */
export const getallocationPendingCountList = async (payload, sendResult) => {
    try {
        let apiendpoint = 'allocation/shipmentlist'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    } catch (error) {
        sendResult(error)
    }
}

/**
 * SEQUENCE Non Allocation Pending Shipments
 */
export const SeqofNonAllocationMobile = async(payload, sendResult) => {
    let apiendpoint = 'allocation/pendingpriorityshipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * SUBMIT RESAON
 */
export const SubmitReasonMobile1 = async(payload, sendResult) => {
    let apiendpoint = 'allocation/storecannotallocateshipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/* 
New Allocation API's [RVP] - Get Pending RVP Shipment List
*/
export const GetShipmentTableDetails = async (payload, sendResult) => {
    try {
        let apiendpoint = 'api/rvpallocation/reverseshipmentlist'
        let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        sendResult(resultData)
    } catch (error) {
        sendResult(resultData)
    }
}

/* 
New Allocation API's [RVP] - This Api use for multiple Shipment deallocation.
*/
export const bulkDeallocationforrvp = async(payload, sendResult) => {
    let apiendpoint = '/api/shipment/bulk-deallocate'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * Check Scantally Batch Status.
 */
export const ScanTallyBatchStatus = async(payload, sendResult) => {
    let apiendpoint = 'expose/get/checkScanTallyBatchStatus'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * Get All Reverse Pending Priority Shipment.
 */
export const getAllReversePendingPriorityShipments = async(payload, sendResult) => {
    let apiendpoint = 'api/rvpallocation/reversependingpriorityshipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 *
 * @param {Object} payload
 *
 * Store All Reverse Pending Priority Shipment.
 */
export const StoreCantAllocatedShipment = async(payload, sendResult) => {
    let apiendpoint = 'allocation/storecannotallocateshipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
        // console.log('resultData ---------->>', resultData);
    sendResult(resultData)
}

/**
 * @param {Object} payload
 * Get COD details against the user (e.g. debitAmount, pendingAmount etc).
 */
export const getUserCodDetails = async(payload, sendResult) => {
    let apiendpoint = 'api/get-srcoddetails'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}

/**
 * @param {Object} payload
 * Get Missing Shipment and update/Insert shipment Table.
 */
export const getMissingRvpShipmentByHubID = async (payload, sendResult) => {
    let apiendpoint = 'websupport/handlemissingshipments'
    let resultData = await postapicallnetworkservice('POST', apiendpoint, payload)
    sendResult(resultData)
}


//////////////////
// WEBPACK FOOTER
// ./services/modules/newallocationservices.js
// module id = 40
// module chunks = 1